import { APIResponse, toDefaultRequestPayload } from "./common";
import { API as RestAPI } from "aws-amplify";
import { AppContextValue } from "../setup/context-value";
import { IContentEvaluation, ContentEvaluationConfiguration } from "@amzn/ask-legal-domain";

export interface ContentEvaluationConfigurationAPI {
    create(input: IContentEvaluation.CreateContentEvaluationConfigurationInput): Promise<APIResponse<ContentEvaluationConfiguration.Data>>;
    update(input: IContentEvaluation.UpdateContentEvaluationConfigurationInput): Promise<APIResponse<ContentEvaluationConfiguration.Data>>;
    load(id: string): Promise<APIResponse<ContentEvaluationConfiguration.Data>>;
    delete(id: string): Promise<APIResponse<ContentEvaluationConfiguration.Data>>;
    submitContentEvaluation(input: IContentEvaluation.SubmitContentEvaluationInput): Promise<APIResponse<IContentEvaluation.SubmitContentEvaluationOutput>>;
}

/**
 * TEMPORARY: APIs disabled to fix issue in infrastructure stack reorder
 * @todo Remove after fix is deployed
 */
export class ContentEvaluationConfigurationAPIImpl implements ContentEvaluationConfigurationAPI {
    constructor(private context: AppContextValue) {}

    async create(input: IContentEvaluation.CreateContentEvaluationConfigurationInput): Promise<APIResponse<ContentEvaluationConfiguration.Data>> {
        const response: APIResponse<ContentEvaluationConfiguration.Data> = await RestAPI.post(
            "regional-domain",
            "/content-evaluation-configuration/create",
            toDefaultRequestPayload(input)
        );
        return response;
    }

    async update(input: IContentEvaluation.UpdateContentEvaluationConfigurationInput): Promise<APIResponse<ContentEvaluationConfiguration.Data>> {
        const response: APIResponse<ContentEvaluationConfiguration.Data> = await RestAPI.post(
            "regional-domain",
            "/content-evaluation-configuration/update",
            toDefaultRequestPayload(input)
        );
        return response;
    }

    async load(id: string): Promise<APIResponse<ContentEvaluationConfiguration.Data>> {
        const response: APIResponse<ContentEvaluationConfiguration.Data> = await RestAPI.post(
            "regional-domain",
            "/content-evaluation-configuration/load",
            toDefaultRequestPayload(id)
        );
        return response;
    }

    async delete(id: string): Promise<APIResponse<ContentEvaluationConfiguration.Data>> {
        const response: APIResponse<ContentEvaluationConfiguration.Data> = await RestAPI.post(
            "regional-domain",
            "/content-evaluation-configuration/delete",
            toDefaultRequestPayload(id)
        );
        return response;
    }

    async submitContentEvaluation(input: IContentEvaluation.SubmitContentEvaluationInput): Promise<APIResponse<IContentEvaluation.SubmitContentEvaluationOutput>> {
        const response: APIResponse<IContentEvaluation.SubmitContentEvaluationOutput> = await RestAPI.post(
            "regional-domain",
            "/content-evaluation-configuration/submit-content-evaluation",
            toDefaultRequestPayload(input)
        );
        return response;
    }
}
